import React from "react";
import Page from "../Components/Page";
import { useParams } from "react-router-dom";
import useFetchData from "../hooks/useFetchData";
import { IDevice, IFirmware } from "../features/devices/types";
import DeviceForm from "../features/devices/DeviceForm";
import { useTranslation } from "react-i18next";

const newEmptyDevice: IDevice = {
  id: -1,
  name: "",
  device_id: "",
  device_type: "SHELLY_1",
  is_alive_check_enabled: false,
  firmware_id: null,
  data: {},
  states: {},
  values: {},
  timestamps: {},
};

export const NewDevicePage = () => {
  const { t } = useTranslation();
  return (
    <Page title={t("New Device")}>
      <DeviceForm device={newEmptyDevice} firmwares={[]} />
    </Page>
  );
};

export const EditDevicePage = () => {
  const params = useParams();
  const { data: device, isLoading: isDevicesLoading } = useFetchData<IDevice>(
    `/devices/${params.deviceid}`
  );
  const { data: firmwares, isLoading: isFirmwaresLoading } = useFetchData<
    IFirmware[]
  >(`/devices/${params.deviceid}/firmwares`);
  return (
    <Page
      title={device?.name}
      isLoading={isDevicesLoading || isFirmwaresLoading}
    >
      {device && firmwares && (
        <DeviceForm device={device} firmwares={firmwares} />
      )}
    </Page>
  );
};
